import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rdpapaya',
  templateUrl: './rdpapaya.component.html',
  styleUrls: ['./rdpapaya.component.css']
})
export class RdpapayaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
